/*jshint esversion: 9 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import TradeStatistics from '../../../components/TradeStatistics';
import store from "../../../components/stores/Store";

const styles = {
  root: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
  paper: {
    padding: '8px',
    textAlign: 'center',
  },
};
class TradeStatisticsInner extends Component {
  constructor() {
    super();
  }

  async componentDidMount() {
    document.title = "交易记录统计";
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          交易记录统计
        </Typography>
        <TradeStatistics />
        </div>
    );
  }
}

const TradeStatisticsPage = observer(TradeStatisticsInner);

TradeStatisticsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TradeStatisticsPage);
